export const MyEntities = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_284_15608)">
      <path
        d="M5.25 7.58333H6.82325C6.44583 7.88608 6.15008 8.28567 5.985 8.75H5.25V7.58333ZM14 9.625V14H7V9.625C7 8.82058 7.65392 8.16667 8.45833 8.16667H8.75V7.875C8.75 7.39258 9.14258 7 9.625 7H11.375C11.8574 7 12.25 7.39258 12.25 7.875V8.16667H12.5417C13.3461 8.16667 14 8.82058 14 9.625ZM8.16667 9.625V10.5H12.8333V9.625C12.8333 9.46458 12.7021 9.33333 12.5417 9.33333H8.45833C8.29792 9.33333 8.16667 9.46458 8.16667 9.625ZM12.8333 12.8333V11.6667H11.0833V12.25H9.91667V11.6667H8.16667V12.8333H12.8333ZM1.16667 1.75C1.16667 1.428 1.428 1.16667 1.75 1.16667H7.58333C7.90533 1.16667 8.16667 1.428 8.16667 1.75V6.45458C8.4735 6.13958 8.87775 5.92083 9.33333 5.8555V1.75C9.33333 0.785167 8.54817 0 7.58333 0H1.75C0.785167 0 0 0.785167 0 1.75V14H5.83333V12.8333H1.16667V1.75ZM4.08333 7.58333H2.33333V8.75H4.08333V7.58333ZM2.33333 11.0833H4.08333V9.91667H2.33333V11.0833ZM4.08333 2.91667H2.33333V4.08333H4.08333V2.91667ZM7 2.91667H5.25V4.08333H7V2.91667ZM4.08333 5.25H2.33333V6.41667H4.08333V5.25ZM5.25 6.41667H7V5.25H5.25V6.41667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_284_15608">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
